module.exports = __webpack_public_path__ + "static/media/app_icon.ee327995.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gJunior/app_icon.svg
// module id = 321
// module chunks = 21